"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Results = void 0;

var stats_1 = require("./stats");

var user_1 = require("./user");

var upload_file_1 = require("./upload-file");

var streamed_results_1 = require("./streamed-results");

var Results =
/** @class */
function () {
  function Results(data, meta, importer) {
    this.$meta = meta;
    this.$data = data;
    this.$importer = importer;
  }

  Object.defineProperty(Results.prototype, "rawOutput", {
    /**
     * The raw output from the importer including all deleted rows
     * and sequence info
     */
    get: function get() {
      return this.blobOnly(this.$data, 'rawOutput');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "data", {
    /**
     * An array of valid data, key-mapped to the configuration provided
     * (alias of validData)
     */
    get: function get() {
      return this.blobOnly(this.validData, 'data');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "validData", {
    /**
     * An array of valid data, key-mapped to the configuration provided
     */
    get: function get() {
      var res = this.$data.filter(function (v) {
        return v.valid;
      }).filter(function (v) {
        return !v.deleted;
      }).map(function (v) {
        return v.data;
      });
      return this.blobOnly(res, 'validData');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "deletedData", {
    /**
     * Rows of data the user excluded from the final results,
     * key-mapped to the configuration provided
     */
    get: function get() {
      var res = this.$data.filter(function (v) {
        return v.deleted;
      }).map(function (v) {
        return v.data;
      });
      return this.blobOnly(res, 'deletedData');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "allData", {
    /**
     * All data from the original file upload including deleted rows,
     * key-mapped to the configuration provided
     */
    get: function get() {
      return this.blobOnly(this.$data.map(function (v) {
        return v.data;
      }), 'allData');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "batchId", {
    /**
     * The uuid of the batch assigned by Flatfile (use this in internal
     * references for support purposes)
     */
    get: function get() {
      return this.$meta.batchID;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "stats", {
    /**
     * Stats and counts about this file upload
     */
    get: function get() {
      return new stats_1.Stats(this.$meta);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "customer", {
    /**
     * The customer provided in setCustomer
     */
    get: function get() {
      if (this.$meta.endUser) {
        return new user_1.EndUser(this.$meta.endUser);
      }

      return null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "originalFile", {
    /**
     * A File object of the originally uploaded file stored as an AWS url
     */
    get: function get() {
      if (this.$meta.originalFile) {
        return new upload_file_1.UploadFile(this.$meta.originalFile);
      }

      return null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "csvFile", {
    /**
     * Same as originalFile unless it was uploaded in xls format, in which case this is the converted csv file stored as an AWS url
     */
    get: function get() {
      if (this.$meta.originalFile) {
        if (this.$meta.originalFile.filetype === 'csv') {
          return new upload_file_1.UploadFile(this.$meta.originalFile);
        } else {
          if (this.$meta.csvFile) {
            return new upload_file_1.UploadFile(this.$meta.csvFile);
          }
        }
      }

      return null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "fileName", {
    /**
     * The filename of the originally uploaded file
     */
    get: function get() {
      return this.$meta.filename || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "managed", {
    /**
     * If the final upload is managed by a private endpoint or not
     */
    get: function get() {
      return this.$meta.managed || false;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "manual", {
    /**
     * If the data was entered manually instead of via file upload or not
     */
    get: function get() {
      return this.$meta.manual;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "config", {
    /**
     * The parsed and bootstrapped config object used by this importer instance
     */
    get: function get() {
      return this.$meta.config;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "parsingConfig", {
    /**
     * The configuration used by the csv parser PapaParse: https://www.papaparse.com/docs#config
     */
    get: function get() {
      return this.$meta.parsing_config;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "skippedRows", {
    /**
     * The invalid rows that were skipped on submission
     */
    get: function get() {
      return this.$meta.skipped_rows || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "headersRaw", {
    /**
     * The headers before they were matched as given in the original file
     */
    get: function get() {
      return this.$meta.headers_raw || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "headersMatched", {
    /**
     * The headers after they are matched
     */
    get: function get() {
      return this.$meta.headers_matched || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "customColumns", {
    /**
     * An array of any columns that were created during import
     */
    get: function get() {
      return this.$meta.custom_columns;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "categoryFieldMap", {
    /**
     * A mapping of source values to target category values
     */
    get: function get() {
      return this.$meta.category_field_map || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "failureReason", {
    /**
     * The reason for the failure if there was a failure
     */
    get: function get() {
      return this.$meta.failure_reason || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "submittedAt", {
    /**
     * The time that the data was submitted
     */
    get: function get() {
      return this.$meta.submitted_at || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "failedAt", {
    /**
     * The time that the import failed if it failed
     */
    get: function get() {
      return this.$meta.failed_at || null;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "createdAt", {
    /**
     * The time the data began the import, whether via file upload or manual data entry
     */
    get: function get() {
      return this.$meta.created_at;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Results.prototype, "stylesheet", {
    /**
     * The stylesheet of the cells. Make sure to use `allowFormatting=true` in the config.
     */
    get: function get() {
      return this.$meta.stylesheet;
    },
    enumerable: false,
    configurable: true
  });

  Results.prototype.blobOnly = function (v, method, alt) {
    if (alt === void 0) {
      alt = 'nextChunk()';
    }

    if (this.$meta.inChunks) {
      throw new Error("\"" + method + "\" is not accessible when using \"inChunks\". Please see docs for \"" + alt + "\" instead.");
    }

    return v;
  };
  /**
   * Get the next chunk of records
   */


  Results.prototype.nextChunk = function () {
    var _this = this;

    return new Promise(function (resolve, reject) {
      if (!_this.$meta.inChunks) {
        return reject("\"nextChunk()\" is only accessible when using \"inChunks\". Please see docs for \"requestDataFromUser\".");
      }

      _this.$importer.$ready.then(function (child) {
        console.log('child.nextChunk()');
        child.nextChunk().then(function (data) {
          console.log('nextChunk()', data);
          resolve(data.results.length ? new streamed_results_1.StreamedResults(data.results, data.meta) : null);
        }, function (err) {
          console.log('nextChunk(err)', err);
        });
      });
    });
  };

  return Results;
}();

exports.Results = Results;